(function() {
    'use strict';

    var MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
    var MAX_IMAGE_WIDTH = 3840;
    var MAX_IMAGE_HEIGHT = 2160;

    var MESSAGE_INVALID_TYPE = 'Недопустимый формат файла.';
    var MESSAGE_TOO_LARGE = 'Файл слишком большой. Максимум 10 МБ.';
    var MESSAGE_TOO_HIGH_RES = 'Слишком большое разрешение изображения. Максимум 3840×2160.';

    function formatFileSize(bytes) {
        if (bytes >= 1024 * 1024) {
            return (bytes / (1024 * 1024)).toFixed(1) + ' МБ';
        }
        if (bytes >= 1024) {
            return Math.round(bytes / 1024) + ' КБ';
        }
        return bytes + ' Б';
    }

    function matchesAccept(file, acceptAttr) {
        if (!acceptAttr) {
            return true;
        }

        var rules = acceptAttr.split(',')
            .map(function(rule) { return rule.trim().toLowerCase(); })
            .filter(Boolean);
        if (rules.length === 0) {
            return true;
        }

        var fileName = (file.name || '').toLowerCase();
        var fileType = (file.type || '').toLowerCase();

        return rules.some(function(rule) {
            if (rule.indexOf('.') === 0) {
                return fileName.endsWith(rule);
            }
            if (rule.endsWith('/*')) {
                return fileType.indexOf(rule.slice(0, -1)) === 0;
            }
            return fileType === rule;
        });
    }

    function checkImageDimensions(file) {
        return new Promise(function(resolve) {
            if (!file.type || file.type.indexOf('image/') !== 0) {
                resolve(true);
                return;
            }

            var url = URL.createObjectURL(file);
            var img = new Image();
            img.onload = function() {
                URL.revokeObjectURL(url);
                var longSide = Math.max(img.naturalWidth, img.naturalHeight);
                var shortSide = Math.min(img.naturalWidth, img.naturalHeight);
                resolve(longSide <= MAX_IMAGE_WIDTH && shortSide <= MAX_IMAGE_HEIGHT);
            };
            img.onerror = function() {
                URL.revokeObjectURL(url);
                resolve(true);
            };
            img.src = url;
        });
    }

    function initFileDropzone(wrapper) {
        if (!wrapper || wrapper.dataset.fileDropzoneInitialized === 'true') {
            return;
        }
        wrapper.dataset.fileDropzoneInitialized = 'true';

        var input = wrapper.querySelector('[data-role="input"]');
        var box = wrapper.querySelector('.file-dropzone-box');
        var filenameEl = wrapper.querySelector('[data-role="filename"]');
        var filesizeEl = wrapper.querySelector('[data-role="filesize"]');
        var removeBtn = wrapper.querySelector('[data-role="remove"]');
        var caption = wrapper.querySelector('[data-role="caption"]');
        var defaultCaptionText = caption ? caption.textContent : '';

        if (!input || !box) {
            return;
        }

        function showError(message) {
            if (!caption) {
                return;
            }
            caption.classList.add('is-error');
            caption.textContent = '';
            var icon = document.createElement('i');
            icon.className = 'fas fa-circle-exclamation';
            icon.setAttribute('aria-hidden', 'true');
            caption.appendChild(icon);
            caption.appendChild(document.createTextNode(' ' + message));
        }

        function clearError() {
            if (!caption) {
                return;
            }
            caption.classList.remove('is-error');
            caption.textContent = defaultCaptionText;
        }

        function setEmptyState() {
            wrapper.classList.remove('is-filled');
            if (filenameEl) {
                filenameEl.textContent = '';
            }
            if (filesizeEl) {
                filesizeEl.textContent = '';
            }
        }

        function setFilledState(file) {
            wrapper.classList.add('is-filled');
            if (filenameEl) {
                filenameEl.textContent = file.name;
            }
            if (filesizeEl) {
                filesizeEl.textContent = formatFileSize(file.size);
            }
        }

        function rejectFile(message) {
            input.value = '';
            input.setCustomValidity(message);
            setEmptyState();
            showError(message);
        }

        function handleFile(file) {
            if (!file) {
                input.setCustomValidity('');
                setEmptyState();
                clearError();
                return;
            }

            if (!matchesAccept(file, input.getAttribute('accept'))) {
                rejectFile(MESSAGE_INVALID_TYPE);
                return;
            }

            if (file.size > MAX_FILE_SIZE_BYTES) {
                rejectFile(MESSAGE_TOO_LARGE);
                return;
            }

            checkImageDimensions(file).then(function(isWithinResolution) {
                if (!isWithinResolution) {
                    rejectFile(MESSAGE_TOO_HIGH_RES);
                    return;
                }

                input.setCustomValidity('');
                setFilledState(file);
                clearError();
            });
        }

        input.addEventListener('change', function() {
            input._droppedFiles = null;
            handleFile(input.files && input.files[0]);
        });

        function setupDropZoneListeners(target) {
            ['dragenter', 'dragover'].forEach(function(eventName) {
                target.addEventListener(eventName, function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    wrapper.classList.add('is-dragover');
                });
            });

            target.addEventListener('dragleave', function(e) {
                if (e.target === target) {
                    wrapper.classList.remove('is-dragover');
                }
            });

            target.addEventListener('drop', function(e) {
                e.preventDefault();
                e.stopPropagation();
                wrapper.classList.remove('is-dragover');

                var files = e.dataTransfer?.files;
                if (files && files.length > 0) {
                    var file = files[0];
                    handleFile(file);
                    input._droppedFiles = files;
                }
            });
        }

        setupDropZoneListeners(box);
        setupDropZoneListeners(wrapper);

        if (removeBtn) {
            removeBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                input.value = '';
                input._droppedFiles = null;
                input.setCustomValidity('');
                setEmptyState();
                clearError();
                input.focus();
            });
        }

        var form = input.closest('form');
        if (form) {
            form.addEventListener('reset', function() {
                window.setTimeout(function() {
                    input._droppedFiles = null;
                    input.setCustomValidity('');
                    setEmptyState();
                    clearError();
                }, 0);
            });
        }
    }

    function initFileDropzones(root) {
        var scope = root || document;
        var wrappers = scope.querySelectorAll('[data-file-dropzone]');
        wrappers.forEach(function(wrapper) {
            initFileDropzone(wrapper);
        });
    }

    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                initFileDropzones();
            });
        } else {
            initFileDropzones();
        }

        if (typeof window !== 'undefined') {
            window.initFileDropzones = initFileDropzones;
        }
    }
})();
